import styled from 'styled-components';

export const Main = styled.main`
  flex: 1 0 auto;
  margin-top: 48px;
  height: auto;
  width: auto;
  background-color:rgb(255,255,255) !important;

  .ms-Stack {
    row-gap: 10px;
    column-gap: 10px;
    &.Container {
      margin-top: 48px;
      margin-bottom: 48px;
      margin-left: 5%;
      margin-right: 5%;
    }
  }

  .ms-StackItem {
    margin-right: auto;
  }

  .ms-Button {
    margin-right: auto;
  }

  .ms-Spinner {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 9999999;
    background-color: rgb(0, 0, 0, 0.3);
  }

  @media (max-width: 1025px) {
    &.navCollapsed {
      margin-left: 48px;
      width: calc(100% - 48px);
    }

    &.navExpanded {
      margin-left: 228px;
      width: calc(100% - 228px);
    }
  }
  
  @media (min-width: 1026px) {
    &.navCollapsed {
      margin-left: 48px;
      width: calc(100% - 48px);
    }

    &.navExpanded {
      margin-left: 228px;
      width: calc(100% - 228px);
    }
  }
`;
